import { Injectable } from '@angular/core';
import { Tokenparams } from '../models/tokenparams';

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {

  constructor() { }

  public setAuthorizationData(auth: Tokenparams): void {
    sessionStorage.setItem("Authorization", JSON.stringify(auth));
  }

  public getAuthorizationData(): Tokenparams {
    let tokenData = JSON.parse(sessionStorage.getItem("Authorization"));
    return tokenData == null ? null : tokenData;
  }


  public getLoginUserName() {
    let currentUserEmail = JSON.parse(sessionStorage.getItem("currentUserEmail"));



    return currentUserEmail;

  }


}
